import React from 'react'
import { noop } from 'lodash'
import { useGesture } from '../GestureProvider'
import { DragEventData } from '../../types/gesture-types'
import { Cursor } from '../../types/types'

type ViewportProps = {
  x: number
  y: number
  width: number
  height: number
  cursor: Cursor
  onPanStart: (event: DragEventData) => void
  onPanMove: (event: DragEventData) => void
  onPanEnd: (event: DragEventData) => void
}

const Viewport: React.FC<ViewportProps> = props => {
  const { x, y, width, height, cursor = 'auto', onPanStart = noop, onPanMove = noop, onPanEnd = noop } = props

  const ref = React.useRef(null)
  const { bindGesture, isDragging } = useGesture()

  // Use our gesture context to bind gesture handlers
  const bind = bindGesture(
    {
      onDragStart: ({ event, deltaX, deltaY }) => {
        onPanStart({ event, deltaX, deltaY })
      },
      onDragMove: ({ event, deltaX, deltaY }) => {
        onPanMove({
          event,
          deltaX,
          deltaY,
        })
      },
      onDragEnd: ({ event, deltaX, deltaY }) => {
        onPanEnd({ event, deltaX, deltaY })
      },
    },
    {
      axis: 'x',
    }
  )

  const style: React.CSSProperties = {
    left: x,
    top: y,
    width,
    height,
    cursor,
    touchAction: 'pan-y', // Allow vertical scrolling, prevent horizontal browser gestures
    userSelect: isDragging ? 'none' : 'auto', // Disable text selection during dragging
  }
  return (
    <div className="viewport" style={style} ref={ref} {...bind()}>
      <div className="gripper">
        <div className="grip"></div>
        <div className="grip"></div>
        <div className="grip"></div>
      </div>
    </div>
  )
}
export default Viewport
